/* eslint-disable no-console */
import Wrap, {
  StyledButton as Button,
  TransparentButton,
  Preview,
} from './styles';

import { default as LayerModel } from 'services/models/Layer';

import LayersList from './components/LayersList';

import MetadataView from '../../../../../../../../components/MetadataView';
import MobileHeader from '../../../../../MobileHeader';

import AppContext from 'views/MapView/services/context';

import Icon from '@map/components/Icons';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useState, useContext, useEffect, useRef } from 'react';
import Mobile from 'views/MapView/components/Mobile';
import { useModule, useMap } from 'views/MapView/hooks';

const StyledMenuItem = withStyles({
  root: {
    fontSize: '14px',
    '&:focus': {
      textDecoration: 'none',
      color: 'inherit',
    },
  },
})(MenuItem);

// TODO Criar referencia de pacotes que estão no AdmView de forma universal

export default () => {
  const [showingDetails, setShowingDetails] = useState(false);
  const [activeNode, setActiveNode] = useState(null);
  const [selected, setSelected] = useState(false);
  const [allModuleLayers, setAllModuleLayers] = useState(null);

  //State para os metadados
  const [hasMetadata, setHasMetadata] = useState(null);
  const [layerMetadata, setLayerMetadata] = useState(null);
  const [metadataPageLink, setMetadataPageLink] = useState(null);
  const [serviceLink, setServiceLink] = useState(null);
  const [canShowLinkService, setCanShowLinkService] = useState(false);
  const [avaliableWMSServiceLink, setAvaliableWMSServiceLink] = useState(false);
  const [avaliableWFSServiceLink, setAvaliableWFSServiceLink] = useState(false);

  //State Preview
  const [urlPreview, setUrlPreview] = useState(null);
  const [isLoadingPreviewImage, setIsLoadingPreviewImage] = useState(false);
  const canvasRef = useRef(null);

  //State Download
  const [canDownload, setCanDownload] = useState(false);
  const [downlaodUrlKml, setDownloadUrlKml] = useState('#');
  const [downlaodUrlShp, setDownloadUrlShp] = useState('#');
  const [hasManualLinkDownload, setHasManualLinkDownload] = useState(false);
  const [manualLinkDownload, setManualLinkDownload] = useState('#');

  // Campo de busca
  const [searchQuery, setSearchQuery] = useState(null);

  //PopOverMenu
  const [anchorEl, setAnchorEl] = useState(null);

  const context = useContext(AppContext);
  const { genericSetContextProp } = context;
  const { activeModule } = useModule();
  const { addLayer } = useMap();

  const getLayersListSelection = (paramSelected) => {
    setSelected(paramSelected);
  };

  const [layerSelected, setLayerSelected] = useState(null);

  const convertImagesToUniqueUrl = async (imagesPreview) => {
    try {
      const loadImages = async () => {
        const urls = imagesPreview;
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
  
        const loadImageFromUrl = (url) => {
          return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'Anonymous'; // Definir crossOrigin
            img.onload = () => resolve(img);
            img.onerror = (error) => reject(error);
            img.src = url;
          });
        };
  
        try {
          let dataUrl;
          const images = await Promise.all(urls.map((url) => loadImageFromUrl(url)));
  
          // Supondo que todas as imagens têm a mesma largura e altura
          const imgWidth = images[0].width;
          const imgHeight = images[0].height;
  
          // Definindo o tamanho do canvas
          canvas.width = imgWidth * 2;
          canvas.height = imgHeight * 2;
  
          // Posicionar as imagens no canvas
          ctx.drawImage(images[0], 0, imgHeight); // Canto inferior esquerdo
          ctx.drawImage(images[1], imgWidth, imgHeight); // Canto inferior direito
          ctx.drawImage(images[2], 0, 0); // Canto superior esquerdo
          ctx.drawImage(images[3], imgWidth, 0); // Canto superior direito

          //verifica altura da imagem, para caso necessite recorte da imagem
          if(imgHeight>220){
            // Definir as margens de recorte
            const topMargin = 190;
            const bottomMargin = 90;
            const leftMargin = 205;
            const rightMargin = 70;
            // Calcular as coordenadas e dimensões do recorte
            const cropX = leftMargin;
            const cropY = topMargin;
            const cropWidth = canvas.width - leftMargin - rightMargin;
            const cropHeight = canvas.height - topMargin - bottomMargin;
            // Criar um canvas final para redimensionar a imagem recortada para 220x220 pixels
            const finalCanvas = document.createElement('canvas');
            finalCanvas.width = 220;
            finalCanvas.height = 220;
            const finalCtx = finalCanvas.getContext('2d');
            // Desenhar a imagem recortada e redimensionada no novo canvas
            finalCtx.drawImage(
              canvas,
              cropX, cropY, cropWidth, cropHeight, // Origem e tamanho do recorte
              0, 0, 220, 220 // Destino e tamanho no novo canvas
            );
            // Convertendo o canvas recortado para uma URL de dados
            dataUrl = finalCanvas.toDataURL('image/png');
          }else{
            dataUrl = canvas.toDataURL('image/png');
          }
          setUrlPreview(dataUrl);
          setIsLoadingPreviewImage(false);
        } catch (error) {
          console.error('Erro ao carregar imagens:', error);
        }
      };      
      await loadImages();
    }
    catch (error) {
      setUrlPreview(null)
    }
  };

  const showDetails = async (e, nodeId) => {
    setShowingDetails(true);
    setIsLoadingPreviewImage(true);
    setActiveNode(nodeId);

    let layer = allModuleLayers[nodeId];
    setLayerSelected(layer);
    setHasMetadata(null);
    setLayerMetadata(null);
    setMetadataPageLink(null);
    setUrlPreview(null);
    setCanDownload(false);
    setDownloadUrlKml('#');
    setDownloadUrlShp('#');
    setHasManualLinkDownload(layer.hasManualLinkDownload());
    setManualLinkDownload(layer.additionalProps?.link);
    await layer.loadData();

    // Link do serviço
    setServiceLink(layer.getFullServiceLink(layer.getService()));

    //Obtenção dos metadados
    if (layer.getMetadataXmlLink()) {
      setHasMetadata(true);
      setMetadataPageLink(layer.getMetadataPageLink());
      layer
        .loadMetadata()
        .then((metadata) => setLayerMetadata(metadata))
        .catch((error) => setHasMetadata(false));
    } else {
      setHasMetadata(false);
    }

    //Obtenção do BoundingBox, e preview
    layer
      .getPreviewUrl()
      .then((imagesPreview) => {
        imagesPreview &&
          convertImagesToUniqueUrl(imagesPreview);
      })
      .catch((error) => {
        setUrlPreview(null);
        setIsLoadingPreviewImage(false);
      });

    if (layer.canShowLinkService()) {
      setCanShowLinkService(layer.type === 'externa');
      //Obtenção dos links de serviços WMS se o mesmo foi habilitado
      setAvaliableWMSServiceLink(
        layer.canShowInternalEnableService('WMS')
          ? layer.getFullServiceLink('WMS')
          : false
      );
      //Obtenção dos links de serviços WMS se o mesmo foi habilitado
      setAvaliableWFSServiceLink(
        layer.canShowInternalEnableService('WFS')
          ? layer.getFullServiceLink('WFS')
          : false
      );
    }

    //Verificação da permissão de download
    if(layer.properties.disabledServices?.string[0] === 'WMS' ||
       layer.properties.disabledServices?.string[0] === 'WFS'){
      setCanDownload(false);
    }else{
      setCanDownload(layer.canDownload());     
    }
    // setDownloadUrlKml(layer.getDownloadLink('kml'));
    // setDownloadUrlShp(layer.getDownloadLink('shapefile'));
    setDownloadUrlKml(
      layer.additionalProps?.server === 'Link externo'
        ? layer.additionalProps.link
        : layer.getDownloadLink('kml')
    );
    setDownloadUrlShp(
      layer.additionalProps?.server === 'Link externo'
        ? layer.additionalProps.link
        : layer.getDownloadLink('shapefile')
    );
  };

  /**
   * Método para abertura do PopOver de Menu
   */
  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  /**
   * Método para fechar o PopOver ou Menu
   */
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const removeSpecialCharacters = (text) => {                      
    text = text.replace(/['"!@#$%¨&*()_=+[{}?;,><\\|\]]/g, "") 
    // bloqueia caracteres especias, permitindo apenas (`´~^:?)
    setSearchQuery(text);    
  }  
  useEffect(() => {
    if (activeModule) {
      const newAllModuleLayers = activeModule.camadas.camadas.reduce(
        (acc, cur) => {
          return { ...acc, [LayerModel.generateId(cur)]: cur };
        },
        {}
      );
      setAllModuleLayers(newAllModuleLayers);
    }
  }, [activeModule]);

  return (
    <Wrap showingDetails={showingDetails}>
      {showingDetails && (
        <Mobile>
          <MobileHeader
            className="fixed_header"
            title="Detalhe de Camada"
            onClick={(e) => setShowingDetails(false)}
          />
        </Mobile>
      )}
      <aside>
        <header>
          <TextField
            label="Pesquisar camada"
            value={searchQuery}
            onChange={(e) =>
              e.target.value
                ? removeSpecialCharacters(e.target.value)
                : setSearchQuery(null)
            }
          />
          <button>
            <Icon i="map-search" />
          </button>
        </header>
        <div className="list">
          <div className="content">
            <LayersList
              layers={activeModule && activeModule.camadas}
              showDetails={showDetails}
              activeNode={activeNode}
              setShowingDetails={setShowingDetails}
              callback={getLayersListSelection}
              searchQuery={searchQuery}
            />
          </div>
        </div>
        <footer>
          <div className="content">
            <Button
              variant="contained"
              disabled={selected.length <= 0}
              onClick={(e) => {
                let selectedLayers = [];
                selected.forEach((element) => {
                  selectedLayers.push(allModuleLayers[element]);
                });

                //setLayers([], true);
                selectedLayers.forEach((selectedLayer) => {
                  // TODO com sort true estava dando erro, averiguar método
                  addLayer(selectedLayer, null, true);
                  genericSetContextProp('layersCatalogIsOpened', false);
                });
              }}
            >
              Adicionar
            </Button>
          </div>
        </footer>
      </aside>
      <div className="details">
      <canvas ref={canvasRef} style={{ display: 'none' }}></canvas>
        <Preview className="preview" loading={isLoadingPreviewImage}>
          {urlPreview ? (
            <img src={urlPreview} alt="Preview" />
          ) : isLoadingPreviewImage ? (
            <p>
              <Icon i="map-bahia" height="80" width="auto" />
              <br />
              Carregando pré-visualização...
            </p>
          ) : (
            <p>
              Selecione uma camada <br /> para pré-visualizar
            </p>
          )}
        </Preview>
        <div className="metadata">
          <MetadataView
            hasMetadata={hasMetadata}
            layerMetadata={layerMetadata}
            metadataLink={metadataPageLink}
            layerName={layerSelected?.alias}
            layerResume={layerSelected?.properties?.abstract}
            serviceLink={serviceLink}
            canShowLinkService={canShowLinkService}
            avaliableWMSServiceLink={avaliableWMSServiceLink}
            avaliableWFSServiceLink={avaliableWFSServiceLink}
            onlyContent
            descriptionOverflow="100px"
          />
        </div>
        <footer>
          <div className="content">
            <TransparentButton
              disabled={!canDownload}
              {
                ...(
                  hasManualLinkDownload
                  ? {
                    href: manualLinkDownload,
                    target: "_self"
                  }
                  : {
                    onClick: handleClickMenu
                  }
                )
              }
              download
            >
              <GetAppIcon />
              Download
            </TransparentButton>
          </div>
        </footer>
      </div>
      <Menu
        id="download-format-select-catalog"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: -40,
          horizontal: 'center',
        }}
        style={{ zIndex: 2100 }}
      >
        <StyledMenuItem
          component="a"
          href={downlaodUrlKml}
          target="_self"
          download
        >
          KML
        </StyledMenuItem>
        <StyledMenuItem
          component="a"
          href={downlaodUrlShp}
          target="_self"
          download
        >
          Shapefile
        </StyledMenuItem>
      </Menu>
    </Wrap>
  );
};
